window.flow = window.flow || {};

Object.assign(window.flow, {
  initCollectionMenuHoverVideos: function(root) {
    var scope = root || document;

    Array.prototype.forEach.call(scope.querySelectorAll('.flow-collection-menu-items'), function(menu) {
      if (menu.dataset.flowHoverVideoInitialized === 'true') {
        return;
      }

      Array.prototype.forEach.call(menu.querySelectorAll('a'), function(link) {
        link.addEventListener('mouseenter', flow.playCollectionMenuBackVideo);
        link.addEventListener('focusin', flow.playCollectionMenuBackVideo);
        link.addEventListener('mouseleave', flow.pauseCollectionMenuBackVideo);
        link.addEventListener('focusout', flow.pauseCollectionMenuBackVideo);
      });

      menu.dataset.flowHoverVideoInitialized = 'true';
    });
  },
  getCollectionMenuBackVideo: function(link) {
    var back = link && link.querySelector('.flow-collection-menu-item-back');

    return back && back.querySelector('video');
  },
  playCollectionMenuBackVideo: function(event) {
    var video = flow.getCollectionMenuBackVideo(event.currentTarget);
    var playPromise;

    if (!video) {
      return;
    }

    video.muted = true;
    playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function() {});
    }
  },
  pauseCollectionMenuBackVideo: function(event) {
    var video = flow.getCollectionMenuBackVideo(event.currentTarget);

    if (!video) {
      return;
    }

    video.pause();
    // video.currentTime = 0;
  }
});

document.addEventListener('DOMContentLoaded', function() {
  flow.initCollectionMenuHoverVideos();
});
